import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GetAbandonedCheckoutInput } from '../domain/dtos/get-abandoned-checkout-input'
import { GetAbandonedCheckoutOutput } from '../domain/dtos/get-abandoned-checkout-output'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'
import { GetOfferIds } from './get-offer-ids'

export class GetAbandonedCheckout {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: GetAbandonedCheckoutInput, signal?: AbortSignal): Promise<GetAbandonedCheckoutOutput> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.BFF_WEB_URL}/leads/summary/total-leads`,
      body: this.makeBody(input),
      signal,
    })

    if (response.statusCode === HttpStatusCode.OK) {
      return response.data
    }

    throw new GeneralError()
  }

  private makeBody(input: GetAbandonedCheckoutInput) {
    const offerIds = new GetOfferIds().execute({ offerIds: input.offerIds, offers: input.offers })

    return {
      startDate: input.startDate,
      endDate: input.endDate,
      offerIds,
    }
  }
}
